<template>
  <h4 style="margin-top: 20px">
    <span style="color: blue"> User Form and Instructions</span>
  </h4>
  <div style="width: 100%; margin: auto">
    <p>
      Lorem ipsum dolor sit amet. Et laborum autem et molestias commodi in nulla
      dolorem qui obcaecati saepe qui quisquam consectetur et molestias alias ut
      cupiditate blanditiis. Qui repellat perspiciatis non adipisci sunt vel
      facilis quisquam aut esse dignissimos ut sunt consequuntur qui internos
      minima. At tempore voluptatum id recusandae voluptatem et labore
      laudantium ut aspernatur deserunt aut tempora consectetur. Qui itaque nemo
      aut magnam accusantium sed quis illo.
    </p>
    <p>
      Et illo consequatur ab dolor quisquam qui nobis laborum! Ut quia
      exercitationem aut voluptatum iste ut dolores labore ut inventore
      voluptate ut ipsa iusto ea quibusdam repellendus. Non eveniet molestiae et
      aspernatur corrupti qui repellat amet sit rerum deleniti in accusantium
      voluptate. Id tenetur sunt eum deleniti earum qui praesentium suscipit sed
      quia quas ab dicta enim vel numquam mollitia et saepe itaque.
    </p>

    <form
      method="get"
      enctype="application/x-www-form-urlencoded"
      action="/html/codes/html_form_handler.cfm"
    >
      <p>
        <label
          >Name
          <input type="text" name="customer_name" required />
        </label>
      </p>

      <p>
        <label
          >Phone
          <input type="tel" name="phone_number" />
        </label>
      </p>

      <p>
        <label
          >Email
          <input type="email" name="email_address" />
        </label>
      </p>

      <fieldset>
        <legend>Which taxi do you require?</legend>
        <p>
          <label>
            <input type="radio" name="taxi" required value="car" /> Car
          </label>
        </p>
        <p>
          <label>
            <input type="radio" name="taxi" required value="van" /> Van
          </label>
        </p>
        <p>
          <label>
            <input type="radio" name="taxi" required value="tuktuk" /> Tuk Tuk
          </label>
        </p>
      </fieldset>

      <fieldset>
        <legend>Extras</legend>
        <p>
          <label>
            <input type="checkbox" name="extras" value="baby" /> Baby Seat
          </label>
        </p>
        <p>
          <label>
            <input type="checkbox" name="extras" value="wheelchair" />
            Wheelchair Access
          </label>
        </p>
        <p>
          <label>
            <input type="checkbox" name="extras" value="tip" /> Stock Tip
          </label>
        </p>
      </fieldset>

      <p>
        <label
          >Pickup Date/Time
          <input type="datetime-local" name="pickup_time" required />
        </label>
      </p>

      <p>
        <label
          >Pickup Place
          <select id="pickup_place" name="pickup_place">
            <option value="" selected="selected">Select One</option>
            <option value="office">Taxi Office</option>
            <option value="town_hall">Town Hall</option>
            <option value="telepathy">We'll Guess!</option>
          </select>
        </label>
      </p>

      <p>
        <label
          >Dropoff Place
          <input
            type="text"
            name="dropoff_place"
            required
            list="destinations"
          />
        </label>

        <datalist id="destinations">
          <option value="Airport"></option>
          <option value="Beach"></option>
          <option value="Fred Flinstone's House"></option>
        </datalist>
      </p>

      <p>
        <label
          >Special Instructions
          <textarea name="comments" maxlength="500"></textarea>
        </label>
      </p>

      <p><button>Submit Booking</button></p>
    </form>

    <p>
      Ea galisum autem est earum perferendis sed voluptatem quidem cum nihil
      ipsam et fugit quidem. Eum vitae dicta sed culpa eveniet in molestiae
      voluptatibus aut libero rerum id pariatur voluptatem. Rem pariatur
      consequuntur non sint repellendus est quas consequatur. A fugit ipsam ut
      quibusdam voluptatem ad facere dicta et iste galisum vel voluptatem odit.
    </p>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
      tempor incididunt ut labore et dolore magna aliqua. Tortor pretium viverra
      suspendisse potenti. Fermentum dui faucibus in ornare quam. Turpis
      tincidunt id aliquet risus feugiat in ante. Semper risus in hendrerit
      gravida rutrum. Est pellentesque elit ullamcorper dignissim cras. Nisl
      nunc mi ipsum faucibus vitae aliquet. Quam adipiscing vitae proin
      sagittis. Duis tristique sollicitudin nibh sit. Enim nec dui nunc mattis
      enim ut tellus. Nibh praesent tristique magna sit amet purus. Velit ut
      tortor pretium viverra suspendisse potenti nullam. Porta nibh venenatis
      cras sed felis eget velit aliquet. Varius vel pharetra vel turpis. Sit
      amet consectetur adipiscing elit duis. Nulla facilisi nullam vehicula
      ipsum a. Eget aliquet nibh praesent tristique magna. Condimentum mattis
      pellentesque id nibh tortor id aliquet. Leo in vitae turpis massa sed
      elementum tempus. Mauris nunc congue nisi vitae suscipit tellus mauris a
      diam. Eget nullam non nisi est sit amet facilisis magna etiam. Vestibulum
      morbi blandit cursus risus at ultrices mi tempus. Facilisi morbi tempus
      iaculis urna id volutpat. Tellus elementum sagittis vitae et. Felis eget
      nunc lobortis mattis aliquam. Fermentum iaculis eu non diam phasellus
      vestibulum lorem sed. Cras semper auctor neque vitae tempus. Tincidunt dui
      ut ornare lectus sit amet est placerat. Lobortis elementum nibh tellus
      molestie nunc non blandit. Scelerisque fermentum dui faucibus in ornare.
      Arcu cursus vitae congue mauris rhoncus aenean vel elit scelerisque. Ut
      pharetra sit amet aliquam. Lectus vestibulum mattis ullamcorper velit sed
      ullamcorper. Nulla pellentesque dignissim enim sit amet venenatis urna.
      Dolor sit amet consectetur adipiscing elit duis tristique. Ut consequat
      semper viverra nam libero justo. Eleifend donec pretium vulputate sapien
      nec sagittis aliquam. Feugiat in fermentum posuere urna nec. Ipsum
      faucibus vitae aliquet nec ullamcorper sit amet risus nullam. At in tellus
      integer feugiat scelerisque varius morbi. Egestas tellus rutrum tellus
      pellentesque eu tincidunt tortor aliquam nulla. Tristique risus nec
      feugiat in fermentum. Massa placerat duis ultricies lacus. Tristique risus
      nec feugiat in fermentum posuere urna nec. Sapien faucibus et molestie ac
      feugiat sed. Purus in massa tempor nec. Ultrices tincidunt arcu non
      sodales neque sodales ut etiam. Lacus sed turpis tincidunt id aliquet.
      Orci nulla pellentesque dignissim enim sit amet venenatis urna. At
      consectetur lorem donec massa sapien faucibus et molestie. Augue eget arcu
      dictum varius duis at consectetur lorem. Lacus vestibulum sed arcu non
      odio euismod lacinia at quis. Feugiat in ante metus dictum at tempor
      commodo ullamcorper a. Ac tortor vitae purus faucibus ornare suspendisse.
      Sagittis id consectetur purus ut faucibus. Vitae ultricies leo integer
      malesuada nunc vel risus. Aliquam etiam erat velit scelerisque in dictum.
      Ut lectus arcu bibendum at varius vel pharetra vel turpis. Consectetur
      purus ut faucibus pulvinar elementum integer enim. Sapien faucibus et
      molestie ac feugiat sed lectus. Quam vulputate dignissim suspendisse in
      est. Senectus et netus et malesuada fames ac turpis egestas. Mi eget
      mauris pharetra et. Blandit aliquam etiam erat velit scelerisque in dictum
      non. Elementum curabitur vitae nunc sed velit dignissim sodales ut eu.
      Aliquet sagittis id consectetur purus ut faucibus. Dignissim cras
      tincidunt lobortis feugiat vivamus. Fames ac turpis egestas integer eget
      aliquet nibh. Placerat in egestas erat imperdiet. Orci ac auctor augue
      mauris augue neque gravida in fermentum. Cras tincidunt lobortis feugiat
      vivamus at. Odio ut enim blandit volutpat maecenas volutpat blandit
      aliquam etiam. Odio euismod lacinia at quis risus sed vulputate. Vitae
      auctor eu augue ut. Tempus quam pellentesque nec nam aliquam sem et tortor
      consequat. In mollis nunc sed id semper risus in.
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
